import { AppState } from "@/mk2/reducers";

import { AskQuestionState, initialAskQuestionState } from "./FaqAskQuestion.reducers";

export const getFaqAskQuestionState = (state: AppState, faqId: string): AskQuestionState =>
    state.containers.faq.faqAskQuestion[faqId] || initialAskQuestionState;
